<template>
  <div>
    <v-card
      class="align-center justify-start rounded-lg pa-0 text-center white--text"
      flat
      style="background: rgba(0, 0, 0, 0)"
      width="405"
      @click="gotoPostdetail(item.Id)"
    >
      <!-- Image -->
      <v-card-title
        class="mx-0 pa-0 text-center justify-center align-center white--text rounded-lg"
        style="word-break: break-word"
      >
        <v-img
          v-if="getItemType == 'video' && item"
          :src="getThumbnailUrl(item)"
          width="405"
          height="226"
          class="rounded-lg"
          cover
        >
          <v-layout justify-center align-center fill-height class="ma-0 pa-0">
            <v-icon color="white" size="90">mdi-play</v-icon>
          </v-layout>
        </v-img>

        <pdf-thumbline
          v-if="
            getItemType == 'document' &&
            item &&
            item.Files &&
            item.Files.length > 0
          "
          :thumbnailURL="getThumbnailUrl(item)"
        />
      </v-card-title>

      <!-- Action -->
      <v-card-title
        class="mx-1 pa-0 mt-3 defaultColor--text"
        style="word-break: break-word; font-size: 14px; line-height: 20px"
      >
        <v-btn
          text
          color="defaultColor"
          class="white--text font-weight-light"
          @click="loader = 'loading3'"
        >
          <v-icon size="22" left>
            {{
              item.LikeStatus ? 'mdi-cards-heart' : 'mdi-cards-heart-outline'
            }}
          </v-icon>
          {{ item.LikeCount }}
        </v-btn>

        <v-btn
          text
          color="defaultColor"
          class="white--text font-weight-light"
          @click="loader = 'loading3'"
        >
          <m-icon scale="1.1" class="mr-2" :name="'m-comment'" />
          {{ item.CommentCount }}
        </v-btn>

        <v-spacer />

        <v-btn
          text
          color="defaultColor"
          class="white--text font-weight-light"
          @click="viewsUserStatus = true"
        >
          <v-icon size="22" left> mdi-eye </v-icon>
          {{ item.ViewCount }}
        </v-btn>
      </v-card-title>

      <!-- Title -->
      <v-card-title
        class="mx-4 pa-0 mt-0 defaultColorLightTwo--text"
        style="word-break: break-word; font-size: 14px; line-height: 20px"
      >
        <h3 class="mt-2 font-weight-medium">{{ item.Title }}</h3>
      </v-card-title>

      <!-- Date -->
      <v-card-title
        class="mx-4 pa-0 mt-0 defaultColor--text"
        style="word-break: break-word; font-size: 13px; line-height: 20px"
      >
        <h3 class="mt-2 font-weight-regular">
          {{ moment(item.CreatedAt).locale('tr').fromNow() }}
        </h3>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import PdfThumbline from './PdfThumbline.vue';
export default {
  data() {
    return {
      viewsUserStatus: false,
    };
  },
  props: {
    item: Object,
  },
  mounted() {},
  components: { PdfThumbline },
  methods: {},
  computed: {
    getItemType() {
      if (this.item.Title === 'Test Video') {
        console.log('1 :', this.item);
      }
      if (this.item.Files.length > 0) {
        if (this.item.Title === 'Test Video') {
          console.log('2 :', this.item);
        }
        if (
          this.item.Files[0].FileExtension === '.mp4' ||
          this.item.Files[0].FileExtension === '.mov' ||
          this.item.Files[0].FileExtension === '.MP4' ||
          this.item.Files[0].FileExtension === '.MOV'
        ) {
          if (this.item.Title === 'Test Video') {
            console.log('3 :', this.item);
          }
          return 'video';
        } else {
          if (this.item.Title === 'Test Video') {
            console.log('5 :', this.item);
          }
          return 'document';
        }
      } else if (this.item.Properties.length > 0) {
        if (this.item.Title === 'Test Video') {
          console.log('4 :', this.item);
        }

        var vimeoArr = this.item.Properties.filter(
          (x) => x.Key == 'videoLink' && x.Value
        );
        console.log('Vimeo => ', vimeoArr);
        //Properties içinde videolink varsa vimeo videosudur
        if (vimeoArr.length > 0) {
          return 'video';
        }
      }

      return 'document';
    },
    getThumbnailUrl() {
      return (item) => {
        if (!item.Files || item.Files.length === 0) {
          return require('../../../public/images/pdf.png').default;
        }

        if (this.getItemType === 'video') {
          return item.Files[0].ThumbnailUrl
            ? item.Files[0].ThumbnailUrl
            : require('../../../public/images/ThumbVideo.png').default;
        }

        return item.Files[0].ThumbnailUrl
          ? item.Files[0].ThumbnailUrl
          : require('../../../public/images/pdf.png').default;
      };
    },
  },
};
</script>
